





















import { defineComponent, ref } from "@vue/composition-api";
import {
  FundraisingGoalTip,
  InputFundraisingGoalTipSearch,
} from "@scrile/api-provider/dist/api/FundraisingGoalsProvider";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import AvatarDescription from "@/components/AvatarDescription";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import FormatMoney from "@/components/FormatMoney";
import InfiniteScroll from "@/components/InfiniteScroll";

export default defineComponent({
  name: "FundraisingGoalDonations",
  components: {
    AvatarDescription,
    BaseSpinner,
    EmptyContent,
    FormatMoney,
    InfiniteScroll,
  },
  props: {
    goalId: { type: String, required: true },
  },
  setup(props) {
    const loading = ref(false);

    const { enableScroll, items, getFirstPage, getNextPage } = usePager<
      FundraisingGoalTip,
      InputFundraisingGoalTipSearch
    >(async (page: number) => {
      return await providers.FundraisingGoalsProvider.tipSearch({
        data: {
          goalId: props.goalId,
          sort: "AMOUNT,DESC;TIME,DESC",
          page,
        },
      });
    });

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      enableScroll,
      items,
      getNextPage,
    };
  },
});
